import React, { useState } from "react";
import { FaFileExcel } from "react-icons/fa";
import { toast } from "react-toastify";
import useApi from "../../hooks/useApi";
import {
  DEFAULT_ERROR,
  GET_BUSINESS_USERS_EXPORT_URL,
} from "../../api/urls";
import { ExportExcelButton } from "../../components/Admins/UserTableStyles";

const reportFilename = (contentDisposition) => {
  const match = contentDisposition?.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
  if (!match?.[1]) {
    return `business-users-report-${new Date().toISOString().slice(0, 10)}.xlsx`;
  }

  try {
    return decodeURIComponent(match[1].trim().replace(/^"|"$/g, ""));
  } catch {
    return match[1].trim().replace(/^"|"$/g, "");
  }
};

const blobErrorMessage = async (error) => {
  const data = error?.response?.data;
  if (data instanceof Blob && data.type?.includes("application/json")) {
    try {
      const parsed = JSON.parse(await data.text());
      return parsed.error || parsed.message;
    } catch {
      return null;
    }
  }
  return data?.error || data?.message;
};

export const BusinessUsersExportButton = ({ search, sort, businessId }) => {
  const api = useApi();
  const [exporting, setExporting] = useState(false);

  const exportReport = async () => {
    try {
      setExporting(true);
      const response = await api.get(GET_BUSINESS_USERS_EXPORT_URL, {
        params: { search: search || undefined, sort, businessId },
        responseType: "blob",
      });
      const contentType = response.headers?.["content-type"];
      const blob = new Blob([response.data], {
        type:
          contentType ||
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const downloadUrl = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = reportFilename(response.headers?.["content-disposition"]);
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 1000);
      toast.success("Excel report downloaded");
    } catch (error) {
      toast.error((await blobErrorMessage(error)) || DEFAULT_ERROR);
    } finally {
      setExporting(false);
    }
  };

  return (
    <ExportExcelButton
      type="button"
      onClick={exportReport}
      disabled={exporting}
      title="Export all matching business users to Excel"
    >
      <FaFileExcel size={14} />
      {exporting ? "Preparing Excel…" : "Export Excel"}
    </ExportExcelButton>
  );
};
